import { Injectable } from '@angular/core';
import { RentalService } from './Rental.service';

@Injectable({
    providedIn: 'root'
})
export class UnloadCleanupService {

    constructor(private rentalService: RentalService) {
        this.registerUnloadHandler();
    }

    private registerUnloadHandler(): void {
        window.addEventListener('beforeunload', (event) => {
            try {
                console.log('Unload event fired from service');
                const tabId = sessionStorage.getItem('tabId');
                const key1 = `marketId-${tabId}`;
                const marketId = localStorage.getItem(key1);
                const tempRecordNo = localStorage.getItem('tempRecordNo');

                if (marketId && tempRecordNo) {
                    const payload = {
                        TempRecordNo: tempRecordNo,
                        BoothNumber: ""
                    };
                    this.rentalService.deleteFromTemp(marketId, payload).subscribe((res: any) => {
                    })
                }
            } catch (err) {
                console.warn('Unload cleanup error:', err);
            }
        });
    }
}
